import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {BasicBitmapCountUp} from "../display/BasicBitmapCountUp";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BookOfShadowsGameConfig} from "../BookOfShadowsGameConfig";
import {BookOfShadowsTextStyles} from "../config/BookOfShadowsTextStyles";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite} from "gsap";
import {IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export class BookOfShadowsBetLineWinAmountView extends BaseView {
    private _bgItem: PIXI.Sprite;
    private _item: BasicBitmapCountUp;

    /**
     * @constructs
     */
    constructor() {
        super();

        StageManager.getLayer(BookOfShadowsGameConfig.instance.LAYERS.WIN_AMOUNT_BET_LINES.name).addChild(this);
    }

    // #368
    public showBetlineAmountInitialWin(betWins: IBetWinData[]): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        const container: PIXI.Container = new PIXI.Container();

        container.position.set(360);
        container.alpha = 0;

        betWins.forEach((betWin: IBetWinData, idx: number) => {
            const winAmount: BasicBitmapCountUp = new BasicBitmapCountUp({
                font: {
                    name: "NumbersWinCountUp",
                    size: 8
                },
                tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
            });

            winAmount.stopAt(betWin.multipliedAmount);
            winAmount.y = (idx * 40);

            container.addChild(winAmount);
        });

        if (betWins.length > 15) {
            container.scale.set(0.7);
            container.y -= 80;
        } else if (betWins.length > 10) {
            container.scale.set(0.8);
            container.y -= 50;
        }
        container.pivot.set(0, container.height / 2);

        StageManager.getLayer(BookOfShadowsGameConfig.instance.LAYERS.INITIAL_WIN_AMOUNT_BET_LINES.name).addChild(container);

        tl.to(container, 0.1, {
            alpha: 1
        });
        tl.to(container, 0.3, {
            y: "-=50"
        });
        tl.to(container, 0.1, {
            alpha: 0
        });
        tl.add(() => {
            container.removeChildren();
            StageManager.getLayer(BookOfShadowsGameConfig.instance.LAYERS.INITIAL_WIN_AMOUNT_BET_LINES.name).removeChild(container);
        });

        return tl;
    }

    /**
     * @description To show the items.
     * @param amount
     * @param reelId
     * @param symId
     */
    public show(amount: number, reelId: number, symId: number): void {
        const pos: number[] = Helper.getSymbolPositions(reelId, symId);

        this._item.position.set(pos[0], pos[1]);
        this._item.preCalculateScale(0, amount);
        this._item.stopAt(amount);
        this._item.updateTextLayout();

        this._bgItem.position.set(pos[0], pos[1]);
        this._bgItem.width = this._item.width * 2;
        this._bgItem.height = this._item.height * 2;

        this._bgItem.visible = true;
        this._item.visible = true;
    }

    /**
     * @description To hide the items.
     */
    public hide(): void {
        this._bgItem.visible = false;
        this._item.visible = false;
    }

    /**
     * @inheritDoc
     */
    protected initAnimations() {
        super.initAnimations && super.initAnimations();

        this._bgItem = new PIXI.Sprite(GameResources.getTextures("betLineWinAmountBg")[0]);
        this._bgItem.visible = false;
        this._bgItem.anchor.set(0.5);

        this._item = new BasicBitmapCountUp(BookOfShadowsTextStyles.BETLINE_WIN_AMOUNT);
        this._item.visible = false;

        this.addChild(this._bgItem, this._item);
    }
}